module.exports = __webpack_public_path__ + "static/media/tidal.21d14427.svg";